import React, { useState, useEffect } from "react";
import MyVerticallyCenteredModal from "../imgUpload/modal";
import {
  getAllImages,
  getAppParams,
  deleteImage,
  serachAllImages,
} from "../../api/api";
import LabelImage from "../cards/image";
import InfiniteScroll from "react-infinite-scroll-component";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Listloader from "../loader/content";
import Loader from "../loader/loader";
import "../pages/search.css";
import { UserLang } from "../../store/userStore";

const ImagesTable = (props) => {
  const [modalShow, setModalShow] = useState(false);
  const [allImage, setallImage] = useState([]);
  const [imageNum, setImageNum] = useState(0);
  const [hasMore, sethasMore] = useState(true);
  const [query, setQuery] = useState("");
  const [search, setSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const lan = UserLang.useState((s) => s.lan);

  useEffect(() => {
    const getImage = async () => {
      try {
        setLoading(true);
        const appl = await getAllImages(10, 0);

        const images = appl.data.images;
        const opt = images.map((item) => ({
          value: item.imagekey,
          label: (
            <LabelImage
              url={getAppParams() + item.imagekey}
              name={item.imageName}
            ></LabelImage>
          ),
          key: item.imagekey,
          name: item.imageName,
          id: item._id,
        }));
        const imageCount = appl.data.count;

        setallImage(opt);
        setImageNum(imageCount);
        if (imageCount < 10) {
          sethasMore(false);
        }
        setLoading(false);
      } catch (error) {}
    };
    getImage();
  }, []);

  const handleDelete = async (event, id, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(allImage);
    items.splice(removeId, 1);
    setallImage(items);
    if (id !== undefined && id !== "") {
      try {
        /* eslint-disable no-unused-vars */
        const result = await deleteImage(id);
        /* eslint-disable no-unused-vars */
        toastr.success("Successfully Saved", "Success");
      } catch (error) {
        toastr.error("Error in deleting the Image", "Error");
      }
    } else {
      toastr.error("Delete Id is Missing", "Error");
    }
  };
  const fetchData = async () => {
    if (
      (!search && (query === "" || query !== "")) ||
      (search && query === "")
    ) {
      const length = allImage.length;
      try {
        const appl = await getAllImages(length + 10, length);
        const images = appl.data.images;
        const imageCount = appl.data.count;
        const opt = images.map((item) => ({
          value: item.imagekey,
          label: (
            <LabelImage
              url={getAppParams() + item.imagekey}
              name={item.imageName}
            ></LabelImage>
          ),
          key: item.imagekey,
          name: item.imageName,
          id: item._id,
        }));
        const newArray = [...allImage, ...opt];

        setallImage(newArray);
        setImageNum(imageCount);
        if (imageNum === allImage.length) {
          sethasMore(false);
        }
      } catch (error) {}
    } else {
      const length = allImage.length;
      try {
        const appl = await serachAllImages(length + 10, length, query);

        const pages = appl.data.images;
        const opt = pages.map((item) => ({
          value: item.imagekey,
          label: (
            <LabelImage
              url={getAppParams() + item.imagekey}
              name={item.imageName}
            ></LabelImage>
          ),
          key: item.imagekey,
          name: item.imageName,
          id: item._id,
        }));

        const imageCount = appl.data.count;

        setImageNum(imageCount);
        const newArray = [...allImage, ...opt];

        setallImage(newArray);
        setImageNum(imageCount);
        if (imageNum === allImage.length) {
          sethasMore(false);
        }
      } catch (error) {}
    }
  };

  const getSearchResult = async () => {
    setLoading(true);

    try {
      const appl = await serachAllImages(10, 0, query);
      const pages = appl.data.images;
      const opt = pages.map((item) => ({
        value: item.imagekey,
        label: (
          <LabelImage
            url={getAppParams() + item.imagekey}
            name={item.imageName}
          ></LabelImage>
        ),
        key: item.imagekey,
        name: item.imageName,
        id: item._id,
      }));

      const imageCount = appl.data.count;

      setallImage(opt);
      setImageNum(imageCount);
      if (imageCount === appl.data.images.length) {
        sethasMore(false);
      }
      if (appl.data.images.length < appl.data.limit) {
        sethasMore(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getImageStart = async () => {
    setLoading(true);
    sethasMore(true);
    try {
      const appl = await getAllImages(10, 0);

      const images = appl.data.images;
      const opt = images.map((item) => ({
        value: item.imagekey,
        label: (
          <LabelImage
            url={getAppParams() + item.imagekey}
            name={item.imageName}
          ></LabelImage>
        ),
        key: item.imagekey,
        name: item.imageName,
        id: item._id,
      }));
      const imageCount = appl.data.count;

      setallImage(opt);
      setImageNum(imageCount);
      if (imageCount < 10) {
        sethasMore(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header filter">
                  <h3
                    className={
                      lan === "rtl"
                        ? "card-title float-right"
                        : "card-title float-left"
                    }
                  >
                    Images
                  </h3>

                  <ul
                    className={
                      lan === "rtl"
                        ? "float-left navbar-nav ml-auto "
                        : "float-right navbar-nav ml-auto "
                    }
                  >
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-widget="navbar-search"
                        href="#!"
                        role="button"
                        onClick={(event) => {
                          event.preventDefault();
                          setSearch(!search);
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </a>
                      <div
                        className={
                          search
                            ? "navbar-search-block"
                            : "navbar-search-block none"
                        }
                      >
                        <form
                          className="form-inline"
                          onSubmit={(event) => {
                            event.preventDefault();
                            getSearchResult();
                          }}
                        >
                          <div className="input-group input-group-sm">
                            <input
                              className="form-control form-control-navbar"
                              type="search"
                              placeholder="Search"
                              aria-label="Search"
                              value={query}
                              onChange={(event) => setQuery(event.target.value)}
                            />
                            <div className="input-group-append">
                              <button className="btn btn-navbar" type="submit">
                                <i className="fas fa-search"></i>
                              </button>
                              <button
                                className="btn btn-navbar"
                                type="button"
                                data-widget="navbar-search"
                                onClick={(event) => {
                                  setSearch(false);
                                  getImageStart();
                                }}
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </li>
                    <li className="nav-item">
                      <a
                        href="#!"
                        className="nav-link btn btn-primary"
                        onClick={() => setModalShow(true)}
                        style={{
                          width: "100px",
                          marginTop: "8px",
                          height: "40px",
                          float: "right",
                          color: "#fff",
                        }}
                      >
                        <i className="fas fa-plus"></i> New
                      </a>
                    </li>
                  </ul>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-sm-12">
                            <InfiniteScroll
                              dataLength={allImage.length}
                              hasMore={hasMore}
                              loader={<Listloader></Listloader>}
                              next={fetchData}
                            >
                              <table
                                id="appadmin"
                                className="table table-bordered table-hover dataTable dtr-inline"
                                role="grid"
                                aria-describedby="example2_info"
                                dir={lan === "rtl" ? "rtl" : "ltr"}
                              >
                                <thead>
                                  <tr role="row">
                                    <th
                                      className="sorting_asc"
                                      tabIndex={0}
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      <label
                                        className={
                                          lan === "rtl"
                                            ? "float-right"
                                            : "float-left"
                                        }
                                      >
                                        Image
                                      </label>
                                    </th>

                                    <th
                                      className="sorting"
                                      tabIndex={0}
                                      rowSpan={1}
                                      colSpan={1}
                                    >
                                      <label
                                        className={
                                          lan === "rtl"
                                            ? "float-right"
                                            : "float-left"
                                        }
                                      >
                                        Delete
                                      </label>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {allImage.map((image, index) => (
                                    <tr role="row" key={index} className="even">
                                      <td
                                        className="dtr-control sorting_1"
                                        tabIndex={0}
                                      >
                                        <span
                                          className={
                                            lan === "rtl"
                                              ? "float-right text-muted"
                                              : "float-left text-muted"
                                          }
                                        >
                                          {image.label}
                                        </span>
                                      </td>
                                      <td>
                                        <button
                                          type="button"
                                          className={
                                            lan === "rtl"
                                              ? "float-right btn btn-light"
                                              : "float-left btn btn-light"
                                          }
                                          onClick={(event) =>
                                            handleDelete(event, image.id, index)
                                          }
                                        >
                                          <i className="fa fa-trash"></i> Delete
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </InfiniteScroll>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
        <MyVerticallyCenteredModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          allimage={allImage}
        />
      </section>
    );
  }
};

export default ImagesTable;
